import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth, API } from "../App";
import axios from "axios";
import { Leaf, Menu, X, ShieldCheck } from "lucide-react";
import { useState } from "react";

const links = [
  { to: "/", label: "Manifesto" },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/realta", label: "Realtà" },
  { to: "/eventi", label: "Eventi" },
  { to: "/forum", label: "Forum" },
  { to: "/comunita", label: "Comunità" },
  { to: "/consigli", label: "Consigli" },
  { to: "/contatti", label: "Contattaci" },
];

export default function Navbar() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const logout = async () => {
    await axios.post(`${API}/auth/logout`);
    setUser(null);
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-30 backdrop-blur-md bg-tc-bg/80 border-b border-tc" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <Leaf className="w-5 h-5 text-tc-primary group-hover:rotate-12 transition-transform" />
          <span className="font-serif text-2xl text-tc-primary tracking-tight">Terra Comune</span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {links.map(l => (
            <NavLink
              key={l.to} to={l.to} end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${isActive ? "text-tc-primary" : "text-tc-muted hover:text-tc-primary"}`
              }>
              {l.label}
            </NavLink>
          ))}
          {user?.is_admin && (
            <NavLink to="/admin" data-testid="nav-admin" className={({ isActive }) =>
              `text-sm tracking-wide flex items-center gap-1 ${isActive ? "text-tc-secondary" : "text-tc-secondary/70 hover:text-tc-secondary"}`}>
              <ShieldCheck className="w-3.5 h-3.5" /> Admin
            </NavLink>
          )}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link to="/profilo" data-testid="profile-link" className="text-sm text-tc-muted hover:text-tc-primary">
                {user.name?.split(" ")[0] || "Profilo"}
              </Link>
              <button onClick={logout} data-testid="logout-btn" className="text-sm text-tc-secondary hover:underline">Esci</button>
            </>
          ) : (
            <Link to="/login" data-testid="login-nav-btn" className="btn-outline text-sm !py-2 !px-5">Accedi</Link>
          )}
        </div>

        <button className="md:hidden text-tc-primary" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-tc px-6 py-4 flex flex-col gap-4 bg-tc-bg" data-testid="mobile-menu">
          {links.map(l => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)}
              className={({ isActive }) => `text-sm ${isActive ? "text-tc-primary" : "text-tc-muted"}`}>
              {l.label}
            </NavLink>
          ))}
          {user?.is_admin && <NavLink to="/admin" onClick={() => setOpen(false)} className="text-sm text-tc-secondary">Admin</NavLink>}
          {user ? (
            <>
              <Link to="/profilo" onClick={() => setOpen(false)} className="text-sm text-tc-muted">Profilo</Link>
              <button onClick={() => { setOpen(false); logout(); }} className="text-sm text-tc-secondary text-left">Esci</button>
            </>
          ) : (
            <Link to="/login" onClick={() => setOpen(false)} className="text-sm text-tc-primary">Accedi</Link>
          )}
        </div>
      )}
    </header>
  );
}
